import { render, staticRenderFns } from "./ClientStatus.vue?vue&type=template&id=f188094e&"
import script from "./ClientStatus.vue?vue&type=script&lang=js&"
export * from "./ClientStatus.vue?vue&type=script&lang=js&"
import style0 from "./ClientStatus.vue?vue&type=style&index=0&id=f188094e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports